import React from 'react'

const CopyIcon = () => {
    return (

        <svg className='copy-icon-svg' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 414.44 497.9">
            <path d="M138.73,99.05c-25.13,0-45.36,20.23-45.36,45.35v308.14c0,25.13,20.23,45.35,45.36,45.35h230.35c25.13,0,45.35-20.23,45.35-45.35V144.4c0-25.13-20.23-45.35-45.35-45.35h-230.35ZM136.07,140.09h235.69v316.75h-235.69V140.09Z" />
            <path d="M45.36,0C20.23,0,0,20.23,0,45.35v308.14c0,25.13,20.23,45.35,45.36,45.35h32.51v-41.04h-35.18V41.05h235.69v42.37h42.69v-38.06C321.06,20.24,300.83.01,275.71.01H45.36Z" />
        </svg>
    )
}

export default CopyIcon
